import BreadCrumb from "@/src/components/Shared/BreadCrumbs";

import { useIntl } from "react-intl";
import server from "@/src/api/server";
import Seo from "@/src/components/Shared/Next-seo";

import Blogs from "@/src/components/Home/Blogs";
import {
  checkRedirect,
  mapBlogForListing,
} from "@/src/components/helpers/functions";

// تصنيفات المدونة التي لا يجب فهرستها في محركات البحث
const NOINDEX_CATEGORY_IDS = ["vueUNOz0S", "A62FmzfjA"];

const BlogsPage = ({ blogsData, seoData, noindex }) => {
  const { formatMessage, locale } = useIntl();

  return (
    <div>
      {(seoData?.title?.[locale] || noindex) && (
        <Seo
          title={seoData?.title?.[locale]}
          description={seoData?.description?.[locale]}
          keywords={seoData?.keywords?.[locale]}
          noindex={noindex}
        />
      )}
      <BreadCrumb
        heading={`${formatMessage({ id: "blog" })} -  ${formatMessage({
          id: "categories",
        })}`}
        description={`${formatMessage({
          id: "main",
        })} / ${formatMessage({
          id: "blog",
        })} / ${formatMessage({ id: "categories" })}`}
        background={blogsData?.breadCurmbImage}
      />

      <div className="row">
        <div className="info"></div>
      </div>
      <Blogs blogs={blogsData?.items} />
    </div>
  );
};

export async function getServerSideProps(ctx) {
  const { id } = ctx.params;
  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  const homeResponse = await server.get("/pages/home");
  const blogs = await server.get(`/blogs/category/${id}`);

  const seoPageResponse = await server.get("/pages/seo-data");

  const sectionData = (r) => r?.data?.data?.page?.sections || [];

  const homeData = (section) =>
    sectionData(homeResponse)?.filter((e) => e?.slug == section)?.[0] || [];

  const seoData = sectionData(seoPageResponse)?.find(
    (section) => section?.pageName === "blogs"
  );

  return {
    props: {
      blogsData: {
        ...homeData("intro"),
        breadCurmbImage: homeData("intro")?.items[0]?.backgroundImage,
        items: (blogs?.data?.data?.blogs || []).map((blog) =>
          mapBlogForListing(blog)
        ),
      },
      seoData,
      noindex: NOINDEX_CATEGORY_IDS.includes(id),
    },
  };
}

export default BlogsPage;
